module.exports = __webpack_public_path__ + "static/publicaciones_computer-5e2f6551c4e90d541e6a4dbea86387f1.jpg";